<template>
  <ul class="nav-links left clearfix">
    <a
      v-bind:href="href"
      v-show="showBack"
      v-on:click="go"
    >
      <ui-icon-button color="white" type="normal" icon="arrow_back"></ui-icon-button>
    </a>
    <div
      v-show="!showBack"
      class="logo"
    >
      <router-link class="logo-home-link" to="/" >
        <img class="logo-image" src="~assets/img/logo-somfy.svg" alt="Logo Somfy">
      </router-link>
    </div>
  </ul>
</template>

<script>
  import _ from 'lodash'
  import { backButtonRoutes as routes } from '../Router'
  const homeRoute = '/'

  const initDataFromCurrentRoute = (vue, route) => {
    const hasBackRoute = routes[route]
    vue.showBack = _.isString(hasBackRoute)
    vue.backRoute = (hasBackRoute) ? routes[route] : homeRoute
  }

  export default {
    data: () => {
      return {
        showBack: false,
        backRoute: homeRoute
      }
    },
    created: function () {
      const route = this.$route.name
      initDataFromCurrentRoute(this, route)
    },

    watch: {
      '$route' (to, from) {
        const route = to.name
        initDataFromCurrentRoute(this, route)
      }
    },
    computed: {},
    methods: {
      go (event) {
        event.preventDefault()
        this.$router.push(this.backRoute)
      }
    }
  }
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  @import '~scss/variables';
  @import '~foundation';

  .logo {
    float: left;
    padding-top: 3px;
    height: 43px;

    a.logo-home-link {
      display: block;
      width: 105px;
    }

    img.logo-image {
      width: 100%;
    }
  }
</style>


// WEBPACK FOOTER //
// BackLink.vue?69cbddcb